import { render, staticRenderFns } from "./TheIndividualUsersDialog.vue?vue&type=template&id=940f23e4&scoped=true&lang=pug&"
import script from "./TheIndividualUsersDialog.vue?vue&type=script&lang=js&"
export * from "./TheIndividualUsersDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940f23e4",
  null
  
)

export default component.exports